"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var offers_nudge_1 = require("@reverbdotcom/commons/dist/offers/offers_nudge");
var offers_currency_conversion_1 = require("@reverbdotcom/commons/dist/offers/offers_currency_conversion");
var rql_1 = require("../../schemas/rql");
var react_tracking_1 = require("react-tracking");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var form_group_1 = require("@reverbdotcom/commons/dist/components/form_group");
var NegotiationGetters = require("./negotiation_getters");
var offer_notices_1 = require("@reverbdotcom/commons/dist/offers/offer_notices");
var offer_amount_inputs_1 = require("@reverbdotcom/commons/dist/offers/offer_amount_inputs");
var bind_1 = require("@reverbdotcom/commons/dist/bind");
var currency_1 = require("@reverbdotcom/commons/dist/currency");
var body_input_1 = require("../messages/body_input");
function CounterNotices(_a) {
    var party = _a.party, listing = _a.listing, negotiation = _a.negotiation;
    if (party === rql_1.core_apimessages_NegotiationParty.BUYER) {
        return (React.createElement("p", { className: "offers-form__notice offers-form__notice--purchase" }, I18n.t('discovery.offers.buyerCompletePurchaseNotice', { shopName: listing.shop.name })));
    }
    return (React.createElement("p", { className: "offers-form__notice offers-form__notice--purchase" }, I18n.t('discovery.offers.sellerCompletePurchaseNotice', { buyerName: negotiation.buyer.name })));
}
var UpdateOfferFormFields = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateOfferFormFields, _super);
    function UpdateOfferFormFields(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { photos: [] };
        return _this;
    }
    Object.defineProperty(UpdateOfferFormFields.prototype, "lastOffer", {
        get: function () {
            return NegotiationGetters.lastOffer(this.props.negotiation);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferFormFields.prototype, "shippingPriceInShopCurrency", {
        get: function () {
            return NegotiationGetters.offerOriginalShippingPriceAmount(this.lastOffer);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpdateOfferFormFields.prototype, "messageLabel", {
        get: function () {
            if (this.props.party === rql_1.core_apimessages_NegotiationParty.SELLER) {
                return I18n.t('discovery.offers.sellerMessageLabel');
            }
            return I18n.t('discovery.offers.buyerMessageLabel');
        },
        enumerable: true,
        configurable: true
    });
    UpdateOfferFormFields.prototype.renderOfferError = function () {
        if (!this.props.error) {
            return null;
        }
        return React.createElement("p", { className: "offers-form__error" }, this.props.error);
    };
    UpdateOfferFormFields.prototype.handleMessageChange = function (message) {
        this.props.onOfferChange({ message: message });
    };
    UpdateOfferFormFields.prototype.handlePhotosChange = function (photos) {
        this.setState({ photos: photos });
    };
    Object.defineProperty(UpdateOfferFormFields.prototype, "labelTaxHint", {
        get: function () {
            if (this.props.negotiation.taxIncluded) {
                return " (" + this.props.negotiation.taxIncludedHint + ")";
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    UpdateOfferFormFields.prototype.renderCounterFields = function () {
        if (this.props.action !== rql_1.core_apimessages_NegotiationAction.COUNTER) {
            return null;
        }
        var _a = this.props, offer = _a.offer, listing = _a.listing, party = _a.party, currency = _a.currency, negotiation = _a.negotiation, onOfferChange = _a.onOfferChange;
        var taxHint = negotiation.taxIncluded ? " (" + negotiation.taxIncludedHint + ")" : '';
        var currencyDescription = currency_1.default.get(currency);
        return [
            React.createElement(offer_amount_inputs_1.default, { key: "0", offer: offer, listing: listing, party: party, action: rql_1.core_apimessages_NegotiationAction.COUNTER, currency: currencyDescription.displayCode, taxable: negotiation, onOfferChange: onOfferChange, autoFocus: true }),
            (party === rql_1.core_apimessages_NegotiationParty.BUYER &&
                React.createElement(offers_nudge_1.default, { key: "1", offerAmount: offer.price, originalAmount: listing.price.amount, currency: currency })),
            (party === rql_1.core_apimessages_NegotiationParty.SELLER &&
                React.createElement(form_group_with_input_1.default, { key: "2", label: "" + I18n.t('discovery.offers.label.counterOfferShippingPrice') + taxHint, fieldName: "shippingPrice", inputName: "offer-shipping-price", currencyPrefix: currencyDescription.symbol, value: offer.shippingPrice, updateField: onOfferChange, disabled: false, numberOnly: true, required: true })),
        ];
    };
    UpdateOfferFormFields.prototype.render = function () {
        return (React.createElement("div", { className: "offers-form__body" },
            this.renderOfferError(),
            this.renderCounterFields(),
            React.createElement(offers_currency_conversion_1.default, { offerAmount: this.props.offer.price, shippingPrice: this.shippingPriceInShopCurrency, rates: this.props.exchangeRates, userCurrency: this.props.currency, shopCurrency: this.props.listing.shop.currency }),
            React.createElement(form_group_1.default, { label: this.messageLabel, tagOptional: true },
                React.createElement(body_input_1.ControlledBodyInput, { message: this.props.offer.message, onChange: this.handleMessageChange, photos: this.state.photos, onPhotosChange: this.handlePhotosChange, inputNamespace: "", bodyInputName: "message", productId: this.props.listing.id, isSeller: this.props.party === rql_1.core_apimessages_NegotiationParty.SELLER, allowPhotos: false, isRequired: false })),
            React.createElement("div", { className: "offers-form__notices" },
                React.createElement(offer_notices_1.CombinedSaleAndShippingNotice, { listing: this.props.listing }),
                this.props.action === rql_1.core_apimessages_NegotiationAction.COUNTER &&
                    React.createElement(CounterNotices, tslib_1.__assign({}, this.props)))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferFormFields.prototype, "handleMessageChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], UpdateOfferFormFields.prototype, "handlePhotosChange", null);
    UpdateOfferFormFields = tslib_1.__decorate([
        react_tracking_1.default(function (_a) {
            var action = _a.action;
            return ({
                context: {
                    source: action.toLowerCase() + "_offer",
                },
            });
        })
    ], UpdateOfferFormFields);
    return UpdateOfferFormFields;
}(React.Component));
exports.default = UpdateOfferFormFields;
//# sourceMappingURL=update_offer_form_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/offers/update_offer_form_fields.js
// module id = GYWQ
// module chunks = 20 21